var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJswsteelLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1550 737",
    width: 1550,
    height: 737,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JSW_Group_logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4139.33 1v735.16h-4139.35v-735.16z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ed1c24 } \n\t\t.s1 { fill: #2744a0 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34983",
    className: "s0",
    d: "m882.1 89.1l-127.2 86.7c275.2 7.9 462.2-79.9 462.2-79.9-199.4 97-409.9 105.8-498.3 104.5l-151.5 103.3c0 0 473.6-11.7 775-302.7 0 0-186.3 138.1-460.2 88.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: g34987",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34995",
    className: "s1",
    d: "m1451.8 301.8h-12.4c0 0 5.6 8.4-2.2 19.9l-105 142.8 12.7-135.9c2.5-17.4 16.2-26.8 16.2-26.8h-44.8-113l-119.7 162.7 12.6-135c0.1-0.1 0.2-0.3 0.2-0.4 2.4-17.7 16.3-27.2 16.3-27.2h-13.9l-143.8-0.1v0.1c-7.5-0.4-368.1-17.1-422 79.1 22.1-44.6 37.2-77.1 38.1-78.6h-261.7c2.7 0.9 17.2 8.7 12.3 22.3-13.7 46.6-46.9 154.4-84 234.2-48.5 104.6-158 142.9-233.1 169.7-6.9 2.4-5.8 7.5 1.4 7.5 184.8 1.2 336.6-13.6 451.3-212.5 26.6-46.2 52.8-96.6 73.3-137.7-1.4 3-2.5 6.2-3.2 9.5-23.6 107.3 176.9 114.2 173.9 139.8-2.6 22.6-122 15.7-200.9-10.3-0.3-0.1-0.7-0.3-1.1-0.5-15-5-21.4-13.8-21.4-13.8l0.6 6.1c0 0 0 0 0 0 0 0 0.1 0.4 0.1 0.9l3.2 28.6c3.2 30.2 7.4 72.7 7.4 72.7 0 0 417.5 52.8 425.2-83 5.9-102.7-195.2-115.1-193-137.6 2-21.1 99.9-23.7 159.3-14.9 0.2 0 0.3 0 0.5 0.1 26.5 4.1 30.3 18.5 30.3 18.5l4.3-10c0 0 0.1 0 0.1 0 0.1-0.5 35.9-82.5 39-89.6l-26.9 287.9q0 0.1 0 0.1c-2.4 17.7-16.4 27.2-16.4 27.2h28.2l129.5 0.1 119.8-163-12.7 135.9c-2.4 17.5-16.3 27-16.3 27h13.8 143.9l232.2-315.7z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJswsteelLogo);
export default __webpack_public_path__ + "static/media/jswsteel-logo.0e3318a75a33e60d2668d9658bafd3b8.svg";
export { ForwardRef as ReactComponent };